import React from 'react';
import './App.scss';
import {Hero,Project,Footer} from './containers';
import {Navbar} from './components'

const App = () => {
  return (
    <div>
        <Navbar/>
        <Hero/>
        <Project/>
        <Footer/>
    </div>
  )
}

export default App